import React, {FC, useEffect, useState} from "react"

import {injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import tracking from "@irati-tracking/wellness"
import {RouterLink} from "@irati/ui/src/Link"
import {WellnessLane, WellnessMedia, WellnessMediaType} from "@irati/types"

import {getImageUrlByWidth} from "@shared/wellness/utils"

import marketingService from "@irati/marketing/services/marketing"
import authentication from "@irati/auth"
import {VideoCardBackground, TopShadow, BottomShadow, VideoCardWrapper} from "./styled"
import TopDetails from "./TopDetails"
import BottomDetails from "./BottomDetails"
import LiveVideoCardDetails from "./LiveVideoCardDetails"

interface Props {
  media: WellnessMedia,
  lane?: WellnessLane,
  lanePosition?: number,
  mediaPositionInLane?: number
}

const VideoCard: FC<Props> = ({media, lane, lanePosition, mediaPositionInLane}) => {
  const [wellnessNotificationIdsList, setWellnessNotificationIdsList] = useState<string[]>([])

  const {price, duration, type, thumbnail, courseMediaCount, uuid} = media
  const trackingMedia = () => {
    tracking.clickMedia(media, {lane, lanePosition, mediaPositionInLane})
  }

  useEffect(() => {
    if(media.type === WellnessMediaType.LiveVideo) {
      marketingService.getProfile({userId: authentication.user().uuid})
        .then((marketingProfile) => {
          const idsList = marketingProfile?.settings?.wellnessLiveNotifications?.map((element) => element?.mediaId)
          const result: string[] = []
          result.push(idsList)
          setWellnessNotificationIdsList(result.flat())
        })
    }
  }, [])

  return (
    <RouterLink onClick={trackingMedia} to={`/details/${uuid}`} plain>
      <VideoCardWrapper>
        <VideoCardBackground thumbnail={getImageUrlByWidth(thumbnail, 1024)} margin={[1, 1, 2, 1]}>
          <TopShadow />
          <BottomShadow />
          {media.type === WellnessMediaType.LiveVideo ? (
            <LiveVideoCardDetails media={media} wellnessNotificationIdsList={wellnessNotificationIdsList} />
          ) : (
            <Flex justifyContent="space-between" direction="column" height="100%">
              <TopDetails duration={duration} type={type} mediaCount={courseMediaCount} isPremium={!!price} />
              <BottomDetails media={media} />
            </Flex>
          )}
        </VideoCardBackground>
      </VideoCardWrapper>
    </RouterLink>
  )
}

export default injectIntl(VideoCard)
